module.exports = __webpack_public_path__ + "img/hz-hrt.da2e66a7.jpg";